module.exports = __webpack_public_path__ + "static/media/border-style-alt.868a4992.svg";